export const Actions={
GET_PROJECT_RELATED_DATA_SUCCESS:"GET_PROJECT_RELATED_DATA_SUCCESS",
GET_PROJECT_RELATED_DATA_FAILED:"GET_PROJECT_RELATED_DATA_FAILED",
GET_ALL_VENDER_LIST_DATA_SUCCESS:"GET_ALL_VENDER_LIST_DATA_SUCCESS",
GET_ALL_VENDER_LIST_DATA_FAILED:"GET_ALL_VENDER_LIST_DATA_FAILED",

}